import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import dayjs from "dayjs";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import ErrorProps from "../../../../Component/Errorprops";
import {
  // riskAssessmentSample,
  safetyEndorsementList,
} from "../../../../SampleData/PermitRequestData";

const PermitRequestWO = ({ data }) => {
  const loginInfo = useSelector((state) => state.auth.loginInfo);
  const [workCenters, setWorkCenters] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axiosPrivate
      .get("/selectlist/getallworkcenters")
      .then((res) => {
        setWorkCenters(res.data);
      })
      .catch(() => setWorkCenters([]));
  }, []);

  const requestedBy = loginInfo.firstName
    ? `${loginInfo.firstName} ${loginInfo.lastName || ""}`.trim()
    : loginInfo.userName || loginInfo.email || "";

  const defaultWorkCenter = (data.workCenterIdList || [])
    .filter((item) => item.isDefault === true)
    .map((item) => workCenters.find((wc) => wc.value === item.workCenterId))
    .filter(Boolean)[0];

  const requestedByDept = defaultWorkCenter ? defaultWorkCenter.text : "";

  const initialValues = {
    requiredDate: null,
    // riskAssessmentId: "",
    requiredEndorsements: [],
    workDescription: data.description || "",
  };

  const validationSchema = Yup.object().shape({
    workDescription: Yup.string().required("Work Description is required"),
  });

  const onSubmit = (values) => {
    const payload = {
      eamWorkOrderNumber: data.code,
      eamWorkOrderRef: data.workOrderName,
      assetTag: data.assetCode,
      location: data.locationName,
      workDescription: values.workDescription,
      requiredEndorsements: values.requiredEndorsements,
      priority: data.priorityName,
      requiredDate: values.requiredDate
        ? dayjs(values.requiredDate).toISOString()
        : null,
      requestedBy: requestedBy,
      requestedByDept: requestedByDept,
      // riskAssessmentId: values.riskAssessmentId || null,
    };

    setSubmitting(true);
    axios
      .post("https://hseapidemo.orienseam.com/api/permit-requests/inbound", payload)
      .then(() => {
        toast.success("Permit Request submitted successfully");
         window.open("https://hsedemo.orienseam.com/", "_blank");
        // window.open("http://localhost:3001/", "_blank");
      })
      .catch((err) => {
        console.error("Permit request submit failed", err);
        if (err.response?.status === 409) {
          toast.error("Permit Request already raised for this Work Order");
        } else {
          toast.error("Failed to submit Permit Request");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Box>
              <Typography
                sx={{
                  color: color.sideTitleColor,
                  fontSize: color.fontSizeSide,
                  fontWeight: color.sideWeightFont,
                }}
              >
                Permit Request
              </Typography>
            </Box>
            <Paper
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
              }}
            >
              <Grid container spacing={"1rem"}>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Required Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoItem>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={values.requiredDate}
                        onChange={(newValue) =>
                          setFieldValue("requiredDate", newValue)
                        }
                        slotProps={{
                          textField: { size: "small", fullWidth: true, variant: "standard" },
                        }}
                        fullWidth
                      />
                    </DemoItem>
                  </LocalizationProvider>
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Risk Assessment
                  </Typography>
                  <Autocomplete
                    options={riskAssessmentSample}
                    getOptionLabel={(option) => option.riskCode}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={
                      riskAssessmentSample.find(
                        (risk) => risk.id === values.riskAssessmentId,
                      ) || null
                    }
                    onChange={(_, newValue) =>
                      setFieldValue("riskAssessmentId", newValue ? newValue.id : "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        size="small"
                        placeholder="Select Risk Assessment"
                      />
                    )}
                    fullWidth
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Required Endorsements
                  </Typography>
                  <Autocomplete
                    multiple
                    options={safetyEndorsementList}
                    value={values.requiredEndorsements}
                    onChange={(_, newValue) =>
                      setFieldValue("requiredEndorsements", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        size="small"
                        placeholder="Select"
                      />
                    )}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Work Description *
                  </Typography>
                  <Field
                    as={TextField}
                    name="workDescription"
                    variant="standard"
                    size="small"
                    multiline
                    minRows={1}
                    maxRows={6}
                    placeholder="Enter Work Description"
                    fullWidth
                  />
                  <ErrorMessage name="workDescription">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Work Order Code *
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {data.code}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Work Order Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {data.workOrderName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Asset Code
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {data.assetCode}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Location
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {data.locationName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Priority
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {data.priorityName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Requested By *
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {requestedBy}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Requested By Dept
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                      wordBreak: "break-word",
                    }}
                  >
                    {requestedByDept}
                  </Typography>
                </Grid>
              </Grid>

              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "1.5rem" }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={submitting}
                  startIcon={
                    submitting ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  {submitting ? "Submitting..." : "Submit"}
                </Button>
              </Box>
            </Paper>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default PermitRequestWO;
